import React from 'react'
import { cn } from '../../lib/cn'

/** Bloque skeleton genérico. */
export function Skeleton({ className, ...rest }) {
  return <div className={cn('skeleton', className)} aria-hidden="true" {...rest} />
}

/** Skeleton para una tarjeta KPI. */
export function SkeletonKpi() {
  return (
    <div className="card p-5">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="mt-3 h-8 w-20" />
      <Skeleton className="mt-3 h-3 w-32" />
    </div>
  )
}

/** Skeleton para una tarjeta de contenido. */
export function SkeletonCard() {
  return (
    <div className="card p-6 space-y-4">
      <div className="flex items-center gap-3">
        <Skeleton className="h-12 w-12 rounded-xl" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      </div>
      <Skeleton className="h-20 w-full rounded-xl" />
      <Skeleton className="h-9 w-full rounded-xl" />
    </div>
  )
}

/** Filas skeleton para una tabla. */
export function SkeletonRows({ rows = 6, cols = 5 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="border-b border-hairline">
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="px-4 py-3">
              <Skeleton className="h-4 w-full max-w-[160px]" />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

export default Skeleton
